import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Option } from 'components/ItemPicker/FilterSelectMenu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TeamTypeFilter(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    teamTypes = _ref.teamTypes;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Select, {
    label: t('actions_filter'),
    value: value,
    onChange: onChange,
    children: [/*#__PURE__*/_jsx(Option, {
      value: "",
      children: value ? t('actions_reset_filter') : t('actions_filter_by_type')
    }), teamTypes.map(function (type) {
      return /*#__PURE__*/_jsx(Option, {
        value: type.id,
        children: type.name
      }, type.id);
    })]
  });
}
export default TeamTypeFilter;